import { type JSX } from "react";
import { VerticalSpacing } from "../VerticalSpacing"
import { CTextIcon, StepText } from "./MarketingSteps.styles"
import { Step2PartnerWrapper, Step2Wrapper } from "./Step2.styles"

interface Step2Props {
    leftSide: JSX.Element,
    rightSide: JSX.Element,
    useNormalOrder?: boolean
}

export const Step2 = ({ leftSide, rightSide, useNormalOrder = false }: Step2Props) => {

    const StepToUse = useNormalOrder ? Step2PartnerWrapper : Step2Wrapper;

    return <StepToUse>
        <div>
            {leftSide}
        </div>
        <div>
            <StepText>
                <VerticalSpacing bottom={16}>
                    <CTextIcon>
                        <svg width="24" height="1" viewBox="0 0 24 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line y1="0.5" x2="24" y2="0.5" stroke="#2E77FF" />
                        </svg>
                        <div>
                            Step 2
                        </div>
                    </CTextIcon>
                </VerticalSpacing>
                {rightSide}
            </StepText>
        </div>
    </StepToUse>
}